import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=Inter:wght@300;400;500;700&display=swap');

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    scroll-behavior: smooth;
    min-height: 100%;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: 'Outfit', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    /* Continuous dark blue to premium slate-teal gradient */
    background: linear-gradient(to bottom, #091326 0%, #0d2847 40%, #0c333f 75%, #0f3842 100%);
    background-attachment: fixed;
    background-size: cover;
    color: #e8e8f0;
    line-height: 1.7;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 1rem;
    font-family: 'Outfit', 'Inter', sans-serif;
  }

  h1 {
    font-size: clamp(2rem, 8vw, 4rem);
  }

  h2 {
    font-size: clamp(1.75rem, 5vw, 3rem);
  }

  h3 {
    font-size: clamp(1.5rem, 3vw, 2rem);
  }

  p {
    margin-bottom: 1rem;
    font-weight: 400;
  }

  a {
    color: #4A90E2;
    text-decoration: none;
    transition: color 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      color: #9013FE;
    }
  }

  /* Smooth scrolling */
  @media (prefers-reduced-motion: no-preference) {
    html {
      scroll-behavior: smooth;
    }
  }

  /* Selection styling */
  ::selection {
    background-color: rgba(74, 144, 226, 0.3);
    color: #ffffff;
  }

  /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #0B0E14;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(74, 144, 226, 0.5);
    border-radius: 4px;
    
    &:hover {
      background: rgba(74, 144, 226, 0.7);
    }
  }
`;

export default GlobalStyles;
